import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-desing-object3d',
  templateUrl: './desing-object3d.component.html',
  styleUrls: ['./desing-object3d.component.scss'],
})
export class DesingObject3dComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
